const lazy = path => () => import(`./${path}`);

// 领取
export default [
  // 日结审核详情
  {
    path: "/cash/:customerId/:balanceAmount?",
    name: "cash",
    component: lazy("Cash"),
    meta: {
      title: "领取",
      keepAlive: false
    }
  },
  {
    path: "/SupplementCard",
    name: "SupplementCard",
    component: lazy("SupplementCard"),
    meta: {
      title: "补充银行卡信息",
      keepAlive: false
    }
  },
  {
    path: "/cashAlipay",
    name: "cashAlipay",
    component: lazy("cashAlipay"),
    meta: {
      title: "提现免费",
      keepAlive: false
    }
  }
];
